<script lang="ts">
  import { Container, Row } from "sveltestrap";
  import BookmarkProductsPage from "./BookmarkProductsPage.svelte";
  import ProductSilder from "./ProductSilder.svelte";
  import ProductPageDetails from "./ProductPageDetails.svelte";
  import BrandAndServices from "./BrandAndServices.svelte";
  import ProductTab from "./ProductTab.svelte";
</script>

<BookmarkProductsPage />
<Container fluid>
  <div>
    <Row class="product-page-main p-0">
      <ProductSilder />
      <ProductPageDetails />
      <BrandAndServices />
    </Row>
  </div>
  <ProductTab />
</Container>
